export default __webpack_public_path__ + "static/media/3.35d4f9bc.svg";